import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
  props: {
    MuiSvgIcon: {
      fontSize: 'small'
    }
  },
  palette: {
    secondary: {
      light: '#52c7b8',
      main: '#009688',
      dark: '#00675b',
      contrastText: '#fff'
    },
    primary: {
      main: '#039BE5'
    },
    active: {
      main: '#A5D6A7',
      dark: '#75a478'
    },
    cancelled: {
      main: '#FFAB91',
      dark: '#c97b63'
    },
    proposed: {
      main: '#FFF59D',
      dark: '#cbc26d'
    }
  },
  shape: {
    borderRadius: 2
  },
  typography: {
    fontSize: 14,
    h2: {
      fontSize: `${18 / 16}rem`
    },
    h3: {
      fontSize: `${15 / 16}rem`,
      lineHeight: 1.5
    },
    subtitle2: {
      fontWeight: 'normal'
    },
    body1: {
      fontSize: `${13 / 16}rem`
    },
    body2: {
      fontSize: `${12.5 / 16}rem`
    }
  }
} as any);

export default theme;
